import { useDispatch, useSelector } from "react-redux";
import { call, put, takeLatest, takeEvery, select } from "redux-saga/effects";
import { logOut } from "../login/action";

import { callApi, callApiWithNoAuth, callApiWithNoAuthAPi, Method, request } from "../../api/Api";
import {
  startLoading,
  stopLoading,
  showErrorMessage,
} from "../layout/action";
import {
  GET_PROFILE_STATES,
  setProfileStates,
  getProfileStates,
  PROFILE_DRIVER_ADD_NEW_VEHICLE,
  PROFILE_DRIVER_ADD_NEW_EMAIL,
  PROFILE_DRIVER_ADD_NEW_ADDRESS,
  PROFILE_DRIVER_ADD_NEW_PHONE,
  PROFILE_DRIVER_EDIT_VEHICLE_API,
  PROFILE_DRIVER_EDIT_EMAIL_API,
  PROFILE_DRIVER_EDIT_ADDRESS_API,
  PROFILE_DRIVER_EDIT_PHONE_API,
  GET_PROFILE_VEHICLE_MAKE_STATES,
  SET_PROFILE_VEHICLE_MAKE_STATES,
  setProfileVehicleMakeStates,
  PROFILE_DRIVER_EDIT_DOB_API,
  hideProfileDriverEditAddressModal,
  hideProfileDriverEditEmailModal,
  hideProfileDriverEditPhoneModal,
  hideProfileDriverBirthadayModal,
  PROFILE_DRIVER_GET_STYLING_API,
  SetprofileDriverStylingApi,
  hideProfileDriverLicenseModal,
  PROFILE_DRIVER_DELETE_EMAIL_API,
  hideProfileDriverDeleteEmailModal,
  hideProfileDriverEditVehicleModal,
  hideProfileDriverAddVehicleModal,
  PROFILE_DRIVER_DELETE_VEHICLE_API,
  hideProfileDriverDeleteVehicleModal,
  hideProfileDriverEmailModal,
  hideProfileDriverPhoneModal,
  GET_PROFILE_VEHICLE_DETAILS,
  GET_ACCOUNT_VEHICLE_DETAILS,
  setProfileVehicleDetails,
  setAccountVehicleDetails,
  UPDATE_PROFILE_VEHICLE_ACTIVATE_DEACTIVATE,
  hideProfileDriverVehicleOptionsModal,
  PROFILE_DRIVER_UPDATE_PASSWORD,
  GET_PROFILE_EMAIL_DETAILS,
  setProfileEmailDetails,
  UPDATE_PROFILE_EMAIL_ACTIVATE_DEACTIVATE,
  hideProfileDriverEmailOptionsModal,
  GET_PROFILE_ADDRESS_DETAILS,
  setProfileAddressDetails,
  UPDATE_PROFILE_ADDRESS_ACTIVATE_DEACTIVATE,
  hideProfileDriverAddressOptionsModal,
  GET_PROFILE_PHONE_DETAILS,
  setProfilePhoneDetails,
  UPDATE_PROFILE_PHONE_ACTIVATE_DEACTIVATE,
  hideProfileDriverPhoneOptionsModal,
  hideProfileDriverUpdateUserNameModal,
  setStates,
  GET_STATES,
  GET_MY_ACCOUNT_EDITOR_DATA,
  setMyAccountEditorDataAction,
  setReviewAndOrderEditorDataAction,
  GET_REVIEW_AND_ORDER_EDITOR_DATA,
  setPaymentPageEditorDataAction,
  GET_PAYMENT_PAGE_EDITOR_DATA,
  setCheckboxAgreementTextEditorDataAction,
  GET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA,
  setOrderCompletePageEditorDataAction,
  GET_ORDER_COMPLETE_PAGE_EDITOR_DATA,
  setCitationInformationEditorDataAction,
  GET_CITATION_INFORMATION_EDITOR_DATA,
  setTermsOfUsesEditorDataAction,
  GET_TERMS_OF_USES_EDITOR_DATA,
  setCitationDetailsPageEditorDataAction,
  GET_CITATION_DETAILS_PAGE_EDITOR_DATA,
  setPaymentTextCitationEditorDataAction,
  GET_PAYMENT_TEXT_CITATION_EDITOR_DATA,
  GET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA,
  setPaymentAcceptedTextCitationEditorDataAction,
  setAppealFineHeaderEditorDataAction,
  GET_APPEAL_FINE_HEADER_EDITOR_DATA,
  setNewPermitOrderDataAction,
  GET_NEW_ORDER_PERMIT_DATA,
  getAccountVehicleDetails,
  PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS,
} from "./action";
import { getDriverCitationStates } from "../citation/action";
import {
  getCheckoutSelectAddressStates,
  getCheckoutSelectEmailStates,
  getCheckoutSelectPhoneStates,
} from "../buyPermits/action";
import { getDriverViewOrderStates } from "../vieworder/action";
import { getUserContextData } from "../login/selector";
import _ from "lodash";

export function* callGetProfileStates(action) {
  try {

    const dataLocation = window.location.href
    let url = String(dataLocation)
    let getGroupname = (url) => {
      let f = url.split("/")
      let dats
      for (let i = 2; i < f.length; i++) {
        if (f[i] == "driverportal") {
          dats = f[i + 1]
        }
      }
      return dats
    }
    // if (action.payload === "clientadmin") return;
    const { loginState } = yield select();

    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      url: `/driversaccount/user-name/${action.payload}/${getGroupname(url)}`,
    });
    const { data } = stateResponse;
    yield put(setProfileStates(data));
    yield put(getDriverViewOrderStates(data?.endUserAccountEntity?.id));
    yield put(
      getCheckoutSelectAddressStates({accountId: data?.endUserAccountEntity?.id})
    );
    // yield put(
    //   getCheckoutSelectAddressStates({
    //     accountId: action.payload.values.accountId,
    //   })
    // );
    yield put(getDriverCitationStates(data.endUserAccountEntity.id));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading())
    //yield put(showErrorMessage({ error: err, title: "Get Profile Data" }))
  }
}

export function* watchGetProfileStates() {
  yield takeEvery(GET_PROFILE_STATES, callGetProfileStates);
}

export function* callprofileDriverCreateVehicle(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/vehicle`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    yield put(hideProfileDriverAddVehicleModal());
    yield put(getAccountVehicleDetails(action.payload.profileStore.endUserAccountEntity.id))
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Add New Vehicle" }));
  }
}
export function* watchCreateProfileVehicle() {
  yield takeLatest(
    PROFILE_DRIVER_ADD_NEW_VEHICLE,
    callprofileDriverCreateVehicle
  );
}

export function* callprofileDriverCreateEmail(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/email-address`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(
      getCheckoutSelectEmailStates({
        accountId: action.payload.values.accountId,
      })
    );
    yield put(stopLoading());
    yield put(hideProfileDriverEmailModal());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Add New Email ID" }));
  }
}
export function* watchCreateProfileEmail() {
  yield takeLatest(PROFILE_DRIVER_ADD_NEW_EMAIL, callprofileDriverCreateEmail);
}

export function* callprofileDriverCreateAddress(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/address`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    // yield put(
    //   getCheckoutSelectAddressStates({
    //     accountId: action.payload.values.accountId,
    //   })
    // );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Add New Address" }));
  }
}
export function* watchCreateProfileAddress() {
  yield takeLatest(
    PROFILE_DRIVER_ADD_NEW_ADDRESS,
    callprofileDriverCreateAddress
  );
}


// Billing Address Api

export function* callprofileDriverCreateBillingAddress(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/billing-address`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    // yield put(
    //   getCheckoutSelectAddressStates({
    //     accountId: action.payload.values.accountId,
    //   })
    // );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Add New Billing Address" }));
  }
}
export function* watchCreateProfileBillingAddress() {
  yield takeLatest(
    PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS,
    callprofileDriverCreateBillingAddress
  );
}




export function* callprofileDriverCreatePhone(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/phone`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(
      getCheckoutSelectPhoneStates({
        accountId: action.payload.values.accountId,
      })
    );
    yield put(stopLoading());
    yield put(hideProfileDriverPhoneModal());
    // yield put(hideProfileDriverPhoneOptionsModal())
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Add New Phone" }));
  }
}
export function* watchCreateProfilePhone() {
  yield takeLatest(PROFILE_DRIVER_ADD_NEW_PHONE, callprofileDriverCreatePhone);
}

export function* callprofileDriverEditVehicle(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/update/vehicle`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    yield put(hideProfileDriverEditVehicleModal());
    yield put(hideProfileDriverVehicleOptionsModal());
    yield put(getAccountVehicleDetails(action.payload.profileStore.endUserAccountEntity.id))
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Edit Vehicle" }));
  }
}
export function* watchCreateProfileEditVehicle() {
  yield takeLatest(
    PROFILE_DRIVER_EDIT_VEHICLE_API,
    callprofileDriverEditVehicle
  );
}

export function* callprofileDriverEditEmail(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/update/email-address`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    yield put(hideProfileDriverEditEmailModal());
    yield put(hideProfileDriverEmailOptionsModal());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Edit Email" }));
  }
}
export function* watchCreateProfileEditEmail() {
  yield takeLatest(PROFILE_DRIVER_EDIT_EMAIL_API, callprofileDriverEditEmail);
}

export function* callprofileDriverEditAddress(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/update/address`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
     yield put(
      getCheckoutSelectAddressStates({
        accountId: action.payload.values.accountId,
      })
    );
    yield put(stopLoading());
    yield put(hideProfileDriverEditAddressModal());
    yield put(hideProfileDriverAddressOptionsModal());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Edit Address" }));
  }
}

export function* callprofileDriverDeleteVehicle(action) {
  try {
    let res = { ...action.payload.objectValue };
    yield put(startLoading());
    yield call(callApi, {
      method: Method.DELETE,
      url: `/eua/${action.payload.objectValue.accountId}/vehicle/${action.payload.objectValue.id}`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    yield put(hideProfileDriverDeleteVehicleModal());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Delete Vehicle" }));
  }
}

export function* callprofileDriverDeleteEmailAddress(action) {
  try {
    let res = { ...action.payload.objectValue };
    yield put(startLoading());
    yield call(callApi, {
      method: Method.DELETE,
      url: `/eua/${action.payload.objectValue.accountId}/email-address/${action.payload.objectValue.id}`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    yield put(hideProfileDriverDeleteEmailModal());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Edit Address" }));
  }
}

//  DOB API CALL

export function* callprofileDriverEditDOB(action) {
  try {
    let res = { ...action.payload.value };
    // delete res.accountId
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/update`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    // yield put(hideProfileDriverBirthadayModal());
    yield put(hideProfileDriverLicenseModal());
    yield put(hideProfileDriverUpdateUserNameModal());
  } catch (err) {
    yield put(stopLoading());
    if(action.payload.value.person.driversLicense.number == "" || action.payload.value.person.driversLicense.state.code == "Choose ..."){
      yield put(showErrorMessage({ error: err, title: "Edit License Number & State" }));
    } 
    if(action.payload.value.person.firstName == "" || action.payload.value.person.lastName == "" || action.payload.value.person.middleInitial == ""){
      yield put(showErrorMessage({ error: err, title: "Edit User Name" }));
    }
    // yield put(showErrorMessage({ error: err, title: "Edit DOB" }));
  }
}

export function* watchCreateProfileEditAddress() {
  yield takeLatest(
    PROFILE_DRIVER_EDIT_ADDRESS_API,
    callprofileDriverEditAddress
  );
}

export function* watchProfileDeleteEditAddress() {
  yield takeLatest(
    PROFILE_DRIVER_DELETE_EMAIL_API,
    callprofileDriverDeleteEmailAddress
  );
}
export function* watchProfileDeleteVehicle() {
  yield takeLatest(
    PROFILE_DRIVER_DELETE_VEHICLE_API,
    callprofileDriverDeleteVehicle
  );
}

export function* watchCreateProfileEditDOB() {
  yield takeLatest(PROFILE_DRIVER_EDIT_DOB_API, callprofileDriverEditDOB);
}

export function* callprofileDriverEditPhone(action) {
  try {
    let res = { ...action.payload.values };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.values.accountId}/update/phone`,
    });

    yield put(getProfileStates(action.payload.profileStore.userName));
    yield put(stopLoading());
    yield put(hideProfileDriverEditPhoneModal());
    yield put(hideProfileDriverPhoneOptionsModal());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Edit Phone" }));
  }
}
export function* watchCreateProfileEditPhone() {
  yield takeLatest(PROFILE_DRIVER_EDIT_PHONE_API, callprofileDriverEditPhone);
}

export function* callprofileDriverGetStyling(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      url: `/portal/style/${action.payload}`,
    });
    const { data } = stateResponse;
    // yield put(setProfileVehicleMakeStates(data));
    yield put(SetprofileDriverStylingApi(data));
    yield put(stopLoading());
  } catch (err) {
    // yield put(stopLoading())
    yield put(
      showErrorMessage({ error: err, title: "Get Driver Portal Data" })
    );
  }
}

export function* callGetDriverVehicleMakeStates(action) {
  try {
    const { loginState } = yield select();
    const { userContext } = loginState;
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      // url: "/vehicles/makes",
      url: "/portal/pages/home-without-session/vehicles/makes",
    });
    const { data } = stateResponse;

    const obj = data;
    let other = obj.find((ele) => ele.name == "Other");
    let otherIndex = obj.findIndex((ele) => ele.name == "Other");
    obj.splice(otherIndex, 1);
    obj.push(other);

    yield put(setProfileVehicleMakeStates(obj));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get Profile Data" }));
  }
}

export function* watchGetDriverVehicleMakeStates() {
  yield takeEvery(
    GET_PROFILE_VEHICLE_MAKE_STATES,
    callGetDriverVehicleMakeStates
  );
}

export function* watchProfileDriverStyling() {
  yield takeLatest(PROFILE_DRIVER_GET_STYLING_API, callprofileDriverGetStyling);
}

export function* callGetProfileVehicleDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/vehicle/${action.payload.vehicleId}`,
    });

    const { data } = stateResponse;

    yield put(setProfileVehicleDetails(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Profile Vehicle Data" })
    );
  }
}

export function* watchcallGetProfileVehicleDetails() {
  yield takeEvery(GET_PROFILE_VEHICLE_DETAILS, callGetProfileVehicleDetails);
}




// getVehicleInformation
export function* callGetAccountVehicleDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload.vehicleId}`,
      url: `/eua/${action.payload}`,

      // url: `/eua/${action.payload}`
    });

    const { data } = stateResponse;

    yield put(setAccountVehicleDetails(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Account Vehicle Data" })
    );
  }
}

export function* watchcallGetAccountVehicleDetails() {
  yield takeEvery(GET_ACCOUNT_VEHICLE_DETAILS, callGetAccountVehicleDetails);
}
//end vehicleInformation




export function* callGetProfileVehicleActivateDeactivate(action) {
  try {
    let res = { ...action.payload.data };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.data.accountId}/update/vehicle`,
      // url: `/eua/27/update/vehicle`
    });
    yield put(getProfileStates(action.payload.user));
    yield put(hideProfileDriverVehicleOptionsModal());
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({
        error: err,
        title: "Get Profile Activate || Deactivate",
      })
    );
  }
}

export function* watchcallGetProfileVehicleActivateDeactivate() {
  yield takeEvery(
    UPDATE_PROFILE_VEHICLE_ACTIVATE_DEACTIVATE,
    callGetProfileVehicleActivateDeactivate
  );
}

export function* callprofileUpdatePassword(action) {
  try {
    let res = { ...action.payload };
    // delete res.accountId
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/driversaccount/drivers/update-password`,
    });

    // yield put(getProfileStates(action.payload.profileStore.userName))
    yield put(stopLoading());
    alert("Your Password has been changed");
    // yield put(hideProfileDriverBirthadayModal())
    yield put(logOut());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Edit Password" }));
  }
}

export function* watchProfileUpdatePassword() {
  yield takeLatest(PROFILE_DRIVER_UPDATE_PASSWORD, callprofileUpdatePassword);
}

//======================================>   Driver Profile Email Activat Deactivate  =================>

export function* callGetProfileEmailDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/email-address/${action.payload.EmailId}`,
    });

    const { data } = stateResponse;

    yield put(setProfileEmailDetails(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Profile Email Data" })
    );
  }
}

export function* watchcallGetProfileEmailDetails() {
  yield takeEvery(GET_PROFILE_EMAIL_DETAILS, callGetProfileEmailDetails);
}

export function* callGetProfileEmailActivateDeactivate(action) {
  try {
    let res = { ...action.payload.data };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.data.accountId}/update/email-address`,
      // url: `/eua/27/update/vehicle`
    });
    yield put(getProfileStates(action.payload.user));
    yield put(hideProfileDriverEmailOptionsModal());
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({
        error: err,
        title: "Get Profile Email Activate || Deactivate",
      })
    );
  }
}

export function* watchcallGetProfileEmailActivateDeactivate() {
  yield takeEvery(
    UPDATE_PROFILE_EMAIL_ACTIVATE_DEACTIVATE,
    callGetProfileEmailActivateDeactivate
  );
}

//======================================>   Driver Profile Address Activat Deactivate  =================>

export function* callGetProfileAddressDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/address/${action.payload.AddressId}`,
    });

    const { data } = stateResponse;

    yield put(setProfileAddressDetails(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Profile Address Data" })
    );
  }
}

export function* watchcallGetProfileAddressDetails() {
  yield takeEvery(GET_PROFILE_ADDRESS_DETAILS, callGetProfileAddressDetails);
}

export function* callGetProfileAddressActivateDeactivate(action) {

  try {
    let res = { ...action.payload.data };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.data.accountId}/update/address`,
      // url: `/eua/27/update/vehicle`
    });
    yield put(getProfileStates(action.payload.user));
    yield put(hideProfileDriverAddressOptionsModal());

    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({
        error: err,
        title: "Get Profile Address Activate || Deactivate",
      })
    );
  }
}

export function* watchcallGetProfileAddressActivateDeactivate() {
  yield takeEvery(
    UPDATE_PROFILE_ADDRESS_ACTIVATE_DEACTIVATE,
    callGetProfileAddressActivateDeactivate
  );
}

//======================================>   Driver Profile Address Activat Deactivate  =================>

export function* callGetProfilePhoneDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/phone/${action.payload.PhoneId}`,
    });

    const { data } = stateResponse;

    yield put(setProfilePhoneDetails(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Profile Phone Data" })
    );
  }
}

export function* watchcallGetProfilePhoneDetails() {
  yield takeEvery(GET_PROFILE_PHONE_DETAILS, callGetProfilePhoneDetails);
}

export function* callGetProfilePhoneActivateDeactivate(action) {
  try {
    let res = { ...action.payload.data };
    delete res.accountId;
    yield put(startLoading());
    yield call(callApi, {
      data: res,
      method: Method.POST,
      url: `/eua/${action.payload.data.accountId}/update/phone`,
      // url: `/eua/27/update/vehicle`
    });
    yield put(getProfileStates(action.payload.user));
    yield put(hideProfileDriverPhoneOptionsModal());
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({
        error: err,
        title: "Get Profile Phone Activate || Deactivate",
      })
    );
  }
}

export function* watchcallGetProfilePhoneActivateDeactivate() {
  yield takeEvery(
    UPDATE_PROFILE_PHONE_ACTIVATE_DEACTIVATE,
    callGetProfilePhoneActivateDeactivate
  );
}
export function* callGetStates(action) {
  try {
    const response = yield call(callApiWithNoAuth, {
      method: Method.GET,
      // url: `/addresses/states/${action.payload}`,
      url:`/portal/pages/home-without-session/addresses/states/${action.payload}`,
    });
    const { data } = response;
    const statesList = _.get(response, 'data[0].states', []);
    const canadianState = _.get(response, "data[1].states", []);
    const mexicoStates = _.get(response, "data[2].states", []);
    canadianState.length > 0 && canadianState.unshift({ "canadaState": `Select ${data[1].name === 'Canada' ? "Canadian Provinces" : `Mexican State`}`, "code": "" });
    mexicoStates.length > 0 && mexicoStates.unshift({ "mexicoState": `Select ${data[2].name === 'Canada' ? "Canadian Provinces" : `Mexican State`}`, "code": "" });
    const result = [...statesList, ...canadianState, ...mexicoStates]
    // const res = { states: [] };
    // if (Array.isArray(data) && data.length === 3) {
    //   res.states = [
    //     ...data[0].states,
    //     { mexicoState: "Select Mexicon State" },
    //     ...data[1].states,
    //     { canadaState: "Select Canadian Provinces" },
    //     ...data[2].states,
    //   ];
    // } else if (Array.isArray(data) && data.length === 2  ) {
    //   res.states = [...data[0].states];
    // } else if(Array.isArray(data) && data.length === 1) {
    //   res.states = [...data[0].states];
    // }
    // yield put(setStates(res.states));
    yield put(setStates(result));
  } catch (err) {
    yield put(showErrorMessage({ error: err, title: "Get States" }));
  }
}
export function* watchGetStates() {
  yield takeEvery(GET_STATES, callGetStates);
}

export function* callGetMyAccountEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApi, {
      url: `/portal/pages/driver-account/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setMyAccountEditorDataAction(response?.data[0].text || { text: "" })
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Editor Data" }))
  }
}

export function* watchGetMyAccountEditorDataStates() {
  yield takeEvery(GET_MY_ACCOUNT_EDITOR_DATA, callGetMyAccountEditorData);
}

export function* callGetReviewAndOrderEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApi, {
      url: `/portal/pages/permit-review/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setReviewAndOrderEditorDataAction(response?.data[0].text || { text: "" })
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Review and Order Editor Data" }))
  }
}

export function* watchGetReviewAndOrderEditorDataStates() {
  yield takeEvery(
    GET_REVIEW_AND_ORDER_EDITOR_DATA,
    callGetReviewAndOrderEditorData
  );
}

export function* callGetPaymentPageEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApi, {
      url: `/portal/pages/permit-payment/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setPaymentPageEditorDataAction(response?.data[0].text || { text: "" })
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Payment Page Editor Data" }))
  }
}

export function* watchGetPaymentPageEditorDataStates() {
  yield takeEvery(GET_PAYMENT_PAGE_EDITOR_DATA, callGetPaymentPageEditorData);
}

export function* callGetCheckboxAgreementTextEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApi, {
      url: `/portal/pages/permit-order-cba/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setCheckboxAgreementTextEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Checkbox Agreement Text Editor Data" }))
  }
}

export function* watchGetCheckboxAgreementTextEditorDataStates() {
  yield takeEvery(
    GET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA,
    callGetCheckboxAgreementTextEditorData
  );
}

export function* callGetOrderCompletePageEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApi, {
      url: `/portal/pages/permit-complete/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setOrderCompletePageEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Order Complete Editor Data" }))
  }
}

export function* watchGetOrderCompletePageEditorDataStates() {
  yield takeEvery(
    GET_ORDER_COMPLETE_PAGE_EDITOR_DATA,
    callGetOrderCompletePageEditorData
  );
}

export function* callGetCitationInformationEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      // url: `/portal/pages/citation-info/${action?.payload}`,
      url: `/portal/pages/home-without-session/citation-info/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setCitationInformationEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Citation Information Editor Data" }))
  }
}

export function* watchGetCitationInformationEditorDataStates() {
  yield takeEvery(
    GET_CITATION_INFORMATION_EDITOR_DATA,
    callGetCitationInformationEditorData
  );
}

export function* callGetTermsOfUsesEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      // url: `/portal/pages/terms-conditions/${action?.payload}`,
      url: `/portal/pages/home-without-session/terms-conditions/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setTermsOfUsesEditorDataAction(response?.data[0].text || { text: "" })
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Terms Of Uses Editor Data" }))
  }
}

export function* watchGetTermsOfUsesEditorDataStates() {
  yield takeEvery(GET_TERMS_OF_USES_EDITOR_DATA, callGetTermsOfUsesEditorData);
}

// new order editor
export function* callGetNewOrderPermitEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApi, {
      url: `/portal/pages/permit-order/${action?.payload?.groupName}`,
      method: Method.GET,
    });

    yield put(
      setNewPermitOrderDataAction(response?.data[0].text || { text: "" })
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Citation Information Editor Data" }))
  }
}

export function* watchGetNewOrderPermitDataStates() {
  yield takeEvery(GET_NEW_ORDER_PERMIT_DATA, callGetNewOrderPermitEditorData);
}
// end new order editor

export function* callGetCitationDetailsPageEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      // url: `/portal/pages/citation-details/${action?.payload}`,
      url: `/portal/pages/home-without-session/citation-details/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setCitationDetailsPageEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Citation Details Editor Data" }))
  }
}

export function* watchGetCitationDetailsPageEditorDataStates() {
  yield takeEvery(
    GET_CITATION_DETAILS_PAGE_EDITOR_DATA,
    callGetCitationDetailsPageEditorData
  );
}

export function* callGetPaymentTextCitationEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      // url: `/portal/pages/citation-payment/${action?.payload}`,
      url: `/portal/pages/home-without-session/citation-payment/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setPaymentTextCitationEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Payment Text Citation Editor Data" }))
  }
}

export function* watchGetPaymentTextCitationEditorDataStates() {
  yield takeEvery(
    GET_PAYMENT_TEXT_CITATION_EDITOR_DATA,
    callGetPaymentTextCitationEditorData
  );
}

export function* callGetPaymentAcceptedTextCitationEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      // url: `/portal/pages/citation-paid/${action?.payload}`,
      url: `/portal/pages/home-without-session/citation-paid/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setPaymentAcceptedTextCitationEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Payment Accepted Text Citation Editor Data" }))
  }
}

export function* watchGetPaymentAcceptedTextCitationEditorDataStates() {
  yield takeEvery(
    GET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA,
    callGetPaymentAcceptedTextCitationEditorData
  );
}

export function* callGetAppealFineHeaderEditorData(action) {
  try {
    yield put(startLoading());
    const response = yield call(callApiWithNoAuth, {
      url: `/portal/pages/home-without-session/citation-appeal/${action?.payload}`,
      method: Method.GET,
    });

    yield put(
      setAppealFineHeaderEditorDataAction(
        response?.data[0].text || { text: "" }
      )
    );
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(showErrorMessage({ error: err, title: "Get Appeal Fine Header Editor Data" }))
  }
}

export function* watchGetAppealFineHeaderEditorDataStates() {
  yield takeEvery(
    GET_APPEAL_FINE_HEADER_EDITOR_DATA,
    callGetAppealFineHeaderEditorData
  );
}
